import React from 'react';
import { motion } from 'framer-motion';
import { Star, Shield, Truck } from 'lucide-react';

export const QualityBadges = () => (
  <section className="bg-[#FEFAF3]/80 py-12 md:py-16" data-testid="quality-badges">
    <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12">
      <h2 className="font-serif text-2xl md:text-3xl font-bold text-[#1a3a5c] text-center mb-10">
        QUALITY-FIRST SERVICE
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-12">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#C9A967] to-[#B8860B] rounded-2xl mb-4 shadow-lg">
            <Shield className="h-8 w-8 text-white" />
          </div>
          <h3 className="font-serif text-lg md:text-xl font-semibold text-[#1a3a5c] mb-2">Certified Authentic</h3>
          <p className="text-gray-600 text-sm">All jewelry comes with authenticity certificates and hallmark certification</p>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }} className="text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#C9A967] to-[#B8860B] rounded-2xl mb-4 shadow-lg">
            <Truck className="h-8 w-8 text-white" />
          </div>
          <h3 className="font-serif text-lg md:text-xl font-semibold text-[#1a3a5c] mb-2">Free Insured Delivery</h3>
          <p className="text-gray-600 text-sm">Secure and fully insured delivery to your doorstep at no extra cost</p>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }} className="text-center sm:col-span-2 md:col-span-1">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#C9A967] to-[#B8860B] rounded-2xl mb-4 shadow-lg">
            <Star className="h-8 w-8 text-white" />
          </div>
          <h3 className="font-serif text-lg md:text-xl font-semibold text-[#1a3a5c] mb-2">Premium Craftsmanship</h3>
          <p className="text-gray-600 text-sm">Handcrafted by skilled artisans with decades of jewelry-making expertise</p>
        </motion.div>
      </div>
    </div>
  </section>
);
